import { Button } from "./Button";

export type Position = "left" | "right" | "top" | "bottom";
export type HeightSidebar = "small" | "medium" | "large" | "full";

type SidebarProps = {
    show: boolean;
    onHide: () => void;
    position?: Position;
    radius?: Position | "unset";
    width?: string;
    height?: HeightSidebar;
    children?: React.ReactNode;
    hasButton?: {
        onClickConfirm?: () => void;
        onClickCancel?: () => void;
    }
};

export const Sidebar = (props: SidebarProps) => {
    function handleClick(callback?: () => void) {
        if (callback) { callback(); return; }
        props.onHide();
    }

    const borderRadius = {
        top: "20px 20px 0 0",
        right: "0 20px 20px 0",
        bottom: "0 0 20px 20px",
        left: "20px 0 0 20px",
        unset: "0"
    }[props.radius || "unset"];
    const height = {small: "30%", medium: "50%", large: "80%", full: "100%"}[props.height || "full"];
    const horizontal = props.position === "left" || props.position === "right";

    return (
        <>
            <div className={`sidebar-backdrop ${props.show ? "show" : ""}`} onClick={props.onHide}></div>
            <div
                className={`sidebar ${props.show ? "show" : ""} ${props.position}`}
                style={{
                    width: horizontal ? props.width : "100vw",
                    height: !horizontal ? height : "100vh",
                    borderRadius: borderRadius
                }}
            >
                <button className="close-icons sidebar-close" onClick={props.onHide}>×</button>
                <div className="sidebar-content">
                    {props.children}
                </div>
                {props.hasButton && (
                    <div className="footer-button">
                        <div className={`dialog-footer-btn`}>
                            <Button btn_type='cancel' name='ยกเลิก' 
                                onClick={() => handleClick(props.hasButton?.onClickCancel)} 
                            />
                            <Button btn_type='confirm' name='ยืนยัน' 
                                onClick={() => handleClick(props.hasButton?.onClickConfirm)} 
                            />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};
